import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { HealthAnalysisModel } from '../../model/health-analysis.model';
import { AbstractComponent } from '../../../../../shared/definition/abstract/abstract.component';
import { HealthAnalysisService } from '../../../health-analysis.service';
import { HealthAnalysisTimelineEventModel } from '../../model/health-analysis-timeline-event.model';
import { HEALTH_ANALYSIS_JOURNEY_STEPS } from '../../health-analysis-journey-steps.const';
import { HealthAnalysisJourneyStateModel } from '../../model/health-analysis-journey-state.model';
import { HealthAnalysisJourneyStepEnum } from '../../enum/health-analysis-journey-step.enum';
import { HealthAnalysisSampleFileModel } from '../../model/health-analysis-sample-file.model';

@Component({
  selector: 'app-health-analysis-detail',
  templateUrl: './health-analysis-detail.component.html',
  styleUrl: './health-analysis-detail.component.scss'
})
export class HealthAnalysisDetailComponent extends AbstractComponent {
    files: Array<any> = [];
    loading = true;
    timeline: Array<HealthAnalysisTimelineEventModel>;
    selectedTab = 'detail';

    steps: Array<HealthAnalysisJourneyStateModel> = Object.values(HEALTH_ANALYSIS_JOURNEY_STEPS());
    analysisStep: HealthAnalysisJourneyStateModel;
    analysisStepIndex = 0;

    constructor(
        public dialogRef: MatDialogRef<HealthAnalysisDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public analysis: HealthAnalysisModel,
        public healthAnalysisService: HealthAnalysisService
    ) {
        super()
    }

    public override ngOnInit(): void {
        this.initialize();
    }

    public eventClose(): void {
        this.dialogRef.close();
    }
    protected initialize(): void {
        this.initializeFiles();
        this.healthAnalysisService.getHealthAnalysisTimelineByAnalysisIdentifier(this.analysis.analysisIdentifier).subscribe((timeline) => {
            this.timeline = timeline;
            this.loading = false;
        });
        this.analysisStepIndex = this.steps.findIndex((step) => step.name === this.analysis.step) as number;
        this.analysisStep = this.steps[this.analysisStepIndex];
        if (this.analysisStep.name === HealthAnalysisJourneyStepEnum.RECOLLECTED) {
            this.analysisStepIndex = this.steps.length - 2;
        }
    }
    public initializeFiles(): void {
        if (this.analysis.detail.files) {
            this.files = (this.analysis.detail.files as Array<HealthAnalysisSampleFileModel>).map((file) => ({
                name: file.name,
                size: file.fileSize,
                extension: file.name.split('.')[1]
            }));
        }
    }
}
